export const needs = [
  "connection",
  "acceptance",
  "appreciation",
  "belonging",
  "cooperation",
  "communication",
  "closeness",
  "community",
  "companionship",
  "compassion",
  "consideration",
  "consistency",
  "empathy",
  "inclusion",
  "intimacy",
  "love",
  "mutuality",
  "nurturing",
  "respect/self-respect",
  "safety",
  "security",
  "stability",
  "support",
  "to know and be known",
  "to see and be seen",
  "to understand and be understood",
  "trust",
  "warmth",
  "air",
  "food",
  "movement/exercise",
  "rest/sleep",
  "sexual expression",
  "shelter",
  "touch",
  "water",
  "authenticity",
  "honesty",
  "integrity",
  "presence",
  "joy",
  "play",
  "humor",
  "peace",
  "beauty",
  "communion",
  "ease",
  "equality",
  "harmony",
  "inspiration",
  "order",
  "autonomy",
  "choice",
  "freedom",
  "independence",
  "space",
  "spontaneity",
  "meaning",
  "awareness",
  "celebration of life",
  "challenge",
  "clarity",
  "competence",
  "consciousness",
  "contribution",
  "creativity",
  "discovery",
  "efficacy",
  "effectiveness",
  "growth",
  "hope",
  "learning",
  "mourning",
  "participation",
  "purpose",
  "self-expression",
  "stimulation",
  "to matter",
  "understanding",
];

export const mainNeeds = [
  "connection",
  "physical well-being",
  "honesty",
  "play",
  "peace",
  "autonomy",
  "meaning",
];
